export default __webpack_public_path__ + "static/chart-placebo-94b21a2d25a8e5ce9e76521ae96e2fdd.png";